/**
 *
 * Asynchronously loads the component for PatientOrderSummary
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./PatientOrderSummaryPage"));
